import styles from "./SidebarReportAProblemModal.module.scss";
import { Button, Modal } from "@/components";

const SidebarReportAProblemModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={styles["comp"]}>
        <div className={styles["comp__content"]}>
          <div className={styles["comp__heading"]}>Report a problem</div>
          <div className={styles["comp__description"]}>
            <p>
              Use this action to quickly report a bug, unexpected behavior, or
              UI issue.
            </p>
            <p>
              Share the most important details with the team so the problem can
              be reproduced faster.
            </p>
          </div>
        </div>

        <div className={styles["comp__actions"]}>
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export { SidebarReportAProblemModal };
